import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, RocketIcon, LockIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function RoadmapSlide() {
  return <SlideLayout data-id="element-403" data-mp="3u2k57i2p6h4q">
      <motion.div variants={itemVariants} className="mb-10 text-center" data-id="element-404" data-mp="3u33i2kdhqfbw">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-3" data-id="element-405" data-mp="3pbbr48qfa7l8">
          Open Source First, Expanding Fast
        </h2>
      </motion.div>

      {/* Timeline */}
      <motion.div variants={itemVariants} className="relative max-w-5xl mx-auto mb-10" data-id="element-406" data-mp="2w97nvwwbyi5">
        {/* Connecting Line */}
        <div className="absolute top-10 left-0 w-full h-1 bg-brand-border rounded-full z-0" data-id="element-407" data-mp="guh1huymyjp3" />
        <div className="absolute top-10 left-0 w-1/3 h-1 bg-brand-teal rounded-full z-0 shadow-[0_0_10px_rgba(0,212,170,0.5)]" data-id="element-408" data-mp="cvhy4esjyuzr" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative z-10" data-id="element-409" data-mp="2ip7tkl0p4u80">
          {/* NOW */}
          <div className="flex flex-col items-center" data-id="element-410" data-mp="2enmmxher9c69">
            <div className="w-20 h-20 bg-brand-bg-card border-2 border-brand-teal rounded-full flex items-center justify-center mb-4 shadow-[0_0_20px_rgba(0,212,170,0.2)]" data-id="element-411" data-mp="2x763vexf2t4s">
              <RocketIcon className="w-8 h-8 text-brand-teal" data-id="element-412" data-mp="374kid8zs57ug" />
            </div>
            <div className="bg-brand-teal/10 text-brand-teal font-bold px-4 py-1 rounded-full text-sm mb-3 border border-brand-teal/20" data-id="element-413" data-mp="372hizycqm2d2">
              NOW
            </div>
            <div className="bg-brand-bg-card border border-brand-border rounded-xl p-4 w-full text-center" data-id="element-414" data-mp="3gtuc0ta9uyko">
              <h3 className="text-lg font-bold text-brand-text mb-3" data-id="element-415" data-mp="3kxsbx67f8des">
                Launch Models
              </h3>
              <ul className="space-y-1.5 text-sm text-brand-text-dim" data-id="element-416" data-mp="3utvci7mmk3zm">
                <li className="font-medium text-brand-text" data-id="element-417" data-mp="3ut3r1pmqrmn2">Llama 8B</li>
                <li className="font-medium text-brand-text" data-id="element-418" data-mp="1vhstszltrdn0">Llama 70B</li>
              </ul>
              <p className="text-xs text-brand-text-muted mt-3 pt-3 border-t border-brand-border" data-id="element-419" data-mp="20gx4juoedjfg">
                Fully optimized for FPGA inference
              </p>
            </div>
          </div>

          {/* NEXT */}
          <div className="flex flex-col items-center" data-id="element-420" data-mp="1of5lj5e2qhi4">
            <div className="w-20 h-20 bg-brand-bg border-2 border-brand-border rounded-full flex items-center justify-center mb-4" data-id="element-421" data-mp="22dvi8jwzef5y">
              <ClockIcon className="w-8 h-8 text-brand-text-dim" data-id="element-422" data-mp="1xdhma08nmvoa" />
            </div>
            <div className="bg-brand-bg-card text-brand-text-dim font-bold px-4 py-1 rounded-full text-sm mb-3 border border-brand-border" data-id="element-423" data-mp="2bcz2hr7vx0m1">
              NEXT
            </div>
            <div className="bg-brand-bg-card/50 border border-brand-border rounded-xl p-4 w-full text-center" data-id="element-424" data-mp="2l4d7ufmioun3">
              <h3 className="text-lg font-bold text-brand-text mb-3" data-id="element-425" data-mp="2g4h1wau9et4w">
                Customer Driven
              </h3>
              <ul className="space-y-1.5 text-sm text-brand-text-dim" data-id="element-426" data-mp="2v2t22rguck0t">
                <li data-id="element-427" data-mp="2q3gbbvmumssy">Qwen</li>
                <li data-id="element-428" data-mp="2q481us1la0cd">Kimi</li>
                <li data-id="element-429" data-mp="2q0tybgh6vl3c">MiniMax 2.5 (430B)</li>
                <li data-id="element-430" data-mp="39ogl29bb5ii3">GLM</li>
              </ul>
              <p className="text-xs text-brand-text-muted mt-3 pt-3 border-t border-brand-border" data-id="element-431" data-mp="39pi0epzcwr5m">
                Prioritized by LOIs & design partners
              </p>
            </div>
          </div>

          {/* FUTURE */}
          <div className="flex flex-col items-center" data-id="element-432" data-mp="34pn9imfl01kk">
            <div className="w-20 h-20 bg-brand-bg border-2 border-brand-border border-dashed rounded-full flex items-center justify-center mb-4" data-id="element-433" data-mp="34o2cmq5so6jj">
              <LockIcon className="w-8 h-8 text-brand-text-muted" data-id="element-434" data-mp="2ur7g2ct30g7w" />
            </div>
            <div className="bg-transparent text-brand-text-muted font-bold px-4 py-1 rounded-full text-sm mb-3 border border-dashed border-brand-border" data-id="element-435" data-mp="2h018rujk9eag">
              FUTURE
            </div>
            <div className="bg-transparent border border-dashed border-brand-border rounded-xl p-4 w-full text-center" data-id="element-436" data-mp="2lwrm4a3zdvs6">
              <h3 className="text-lg font-bold text-brand-text-dim mb-3" data-id="element-437" data-mp="2c0ombawlq98e">
                B2B Partnerships
              </h3>
              <p className="text-brand-text-muted text-sm" data-id="element-438" data-mp="3fau1ly4wobdc">
                Closed-source foundation models through exclusive partnerships.
              </p>
              <p className="text-xs text-brand-text-muted mt-3 pt-3 border-t border-dashed border-brand-border" data-id="element-439" data-mp="35m2go9y9irbx">
                Available on the same API
              </p>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div variants={itemVariants} className="flex flex-col md:flex-row gap-4 max-w-4xl mx-auto" data-id="element-440" data-mp="2voxr0057kdqd">
        <div className="flex-1 bg-brand-bg-card border border-brand-border rounded-xl p-4 flex items-start gap-3" data-id="element-441" data-mp="2rkzr3n826yw9">
          <div className="p-2 bg-brand-teal/10 rounded-lg" data-id="element-442" data-mp="2mpapzfge59xu">
            <ClockIcon className="w-5 h-5 text-brand-teal" data-id="element-443" data-mp="2hp51g85f43jz" />
          </div>
          <div data-id="element-444" data-mp="kwd1fvtnd3ip">
            <h4 className="font-bold text-brand-text text-sm mb-1" data-id="element-445" data-mp="kus8ubqw7unh">
              2-Week Turnaround
            </h4>
            <p className="text-xs text-brand-text-dim" data-id="element-446" data-mp="fx9webdo2xaq">
              Our compilation toolchain moves models from source weights to
              FPGA-optimized deployment in days, not months.
            </p>
          </div>
        </div>
        <div className="flex-1 bg-brand-bg-card border border-brand-teal/30 rounded-xl p-4 flex items-start gap-3 relative overflow-hidden" data-id="element-447" data-mp="x62p1bdssrv6">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-teal/5 blur-2xl rounded-full" data-id="element-448" data-mp="124465qrnyh40" />
          <div className="p-2 bg-brand-teal/10 rounded-lg relative z-10" data-id="element-449" data-mp="4igl220nrl7s">
            <RocketIcon className="w-5 h-5 text-brand-teal" data-id="element-450" data-mp="9fylt54iuu4p" />
          </div>
          <div className="relative z-10" data-id="element-451" data-mp="9ibae14sc2qq">
            <h4 className="font-bold text-brand-text text-sm mb-1" data-id="element-452" data-mp="eejmf5norfto">
              You Drive the Priority
            </h4>
            <p className="text-xs text-brand-text-dim" data-id="element-453" data-mp="jg8ymomn9zjc">
              Model priority is driven by you — if a model matters to your
              product, tell us and we will accelerate it.
            </p>
          </div>
        </div>
      </motion.div>
    </SlideLayout>;
}